<template>
  <div class="payouts-in-progress-table">
    <CDataTable
      :items="payouts"
      :fields="fields"
      class="table-payout"
      :no-items-view="{ noResults: $pgettext('payout.inProgress', 'Nessun pagamento in lavorazione') }"
    >
      <!-- Periodo -->
      <template #period="{item}">
        <td class="font-weight-medium text-nowrap">
          {{ (item.date_from || item.created_at) | formatDate('MMMM YYYY') }}
        </td>
      </template>

      <!-- Importo Netto -->
      <template #paid_net="{item}">
        <td>
          <div class="font-weight-medium text-nowrap">
            {{ item.paid_net | currency(currencyCodes.EUR) }}
          </div>
        </td>
      </template>

      <!-- Stato -->
      <template #status="{item}">
        <td>
          <div class="d-flex align-items-center">
            <CBadge :color="getStatusColor(item.status)"  class="badge-outline">
              {{ getStatusLabel(item.status) }}
            </CBadge>
            <CIcon
              v-if="item.status === 'invoice_rejected' && item.invoice_rejected_reason"
              name="cilInfo"
              size="sm"
              class="ml-1 text-danger"
              v-c-tooltip="{content: item.invoice_rejected_reason || ''}"
            />
          </div>
        </td>
      </template>

      <!-- Fattura -->
      <template #invoice="{item}">
        <td>
          <div class="d-flex align-items-center">
            <!-- can_upload_invoice: pulsante carica/ricarica fattura -->
            <template v-if="item.can_upload_invoice">
              <CButton
                color="light"
                size="sm"
                variant="outline"
                style="border-style: dashed;"
                @click.stop="$emit('upload-invoice', item)"
              >
                <CIcon name="cipUpload02" size="sm" class="mr-1 flex-shrink-0 text-primary" style="vertical-align: bottom;" />
                <template v-if="item.status === 'invoice_rejected'">
                  <translate translate-context="payout.inProgress">Re-upload invoice</translate>
                </template>
                <template v-else>
                  <translate translate-context="payout.inProgress">Upload invoice</translate>
                </template>
              </CButton>
            </template>

            <!-- Invoice uploaded: nome file -->
            <template v-else-if="item.invoice">
              <CLink
                :href="item.invoice"
                target="_blank"
                class="d-flex align-items-center text-truncate link-invoice"
              >
                <CIcon name="cipDoc" class="mr-1 flex-shrink-0" />
                <span class="text-truncate">{{ item.invoice_name || 'Invoice' }}</span>
              </CLink>
            </template>

            <span v-else class="">---</span>


          </div>
        </td>
      </template>

      <template #action="{item}">
        <!-- Chevron expand -->
        <td class="text-right">
          <div>
            <CLink @click="onToggleRow(item.id)" class="cursor-pointer">
              <CIcon
                :name="isExpanded(item.id) ? 'cipChevronDown' : 'cipChevronRight'"
                size="custom-size"
                :height="18"
              />
            </CLink>
          </div>
          </td>
      </template>

      <!-- Details slot (expanded row) -->
      <template #details="{item}">
        <CCollapse :show="isExpanded(item.id)">
          <div class="p-3">
            <template v-if="getExpandedData(item.id)">
              <PayoutEventDetail
                v-if="getExpandedData(item.id).pica_services && getExpandedData(item.id).pica_services.length > 0"
                :pica-services="getExpandedData(item.id).pica_services"
                :currency="getExpandedData(item.id).currency || 'EUR'"
                @download="$emit('download-payout-excel', item)"
              />
              <div v-else class="text-center py-3 text-muted">
                <translate translate-context="payout.inProgress">No details available</translate>
              </div>
            </template>
            <div v-else class="text-center py-3">
              <CSpinner size="sm" color="primary" />
            </div>
          </div>
        </CCollapse>
      </template>
    </CDataTable>

    <!-- Alert fattura deadline -->
    <PAlert color="warning" class="mt-3" icon="cipInfo">
      <translate translate-context="payout.inProgress">
        Attach the invoice by the 15th to receive payment at the end of the current month — otherwise the payment will be made the following month.
      </translate>
    </PAlert>
  </div>
</template>

<script>
import { PAYOUT_STATUS_LABELS, PAYOUT_STATUS_VARIANTS } from '../constants'
import PayoutEventDetail from './PayoutEventDetail.vue'
import {currencyCodes} from "@/constants";
import PAlert from "@/components/PAlert.vue";

export default {
  name: 'PayoutsInProgressTable',
  computed: {
    currencyCodes() {
      return currencyCodes
    }
  },
  components: {
    PAlert,
    PayoutEventDetail
  },
  props: {
    payouts: {
      type: Array,
      required: true
    },
    expandedData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      expandedRows: [],
      fields: [
        {
          key: 'period',
          label: this.$pgettext('payout.inProgress', 'PERIOD'),
          _style: 'width: 200px'
        },
        {
          key: 'paid_net',
          label: this.$pgettext('payout.inProgress', 'NET AMOUNT'),
          _style: 'width: 150px'
        },
        {
          key: 'status',
          label: this.$pgettext('payout.inProgress', 'STATUS'),
          _style: 'width: 140px'
        },
        {
          key: 'invoice',
          label: this.$pgettext('payout.inProgress', 'INVOICE'),
          _style: 'width: 200px'
        },
        {
          key: 'action',
          label: '',
          _style: 'width: 50px'
        }
      ]
    }
  },
  methods: {
    onToggleRow(id) {
      const idx = this.expandedRows.indexOf(id)
      if (idx > -1) {
        this.expandedRows.splice(idx, 1)
      } else {
        this.expandedRows.push(id)
        this.$emit('expand', id)
      }
    },
    isExpanded(id) {
      return this.expandedRows.includes(id)
    },
    getExpandedData(id) {
      return this.expandedData[id] || null
    },
    getStatusLabel(status) {
      return PAYOUT_STATUS_LABELS[status] || status
    },
    getStatusColor(status) {
      return PAYOUT_STATUS_VARIANTS[status] || 'secondary'
    }
  }
}
</script>

<style scoped>

</style>
